import React, { Component } from 'react';

class Legal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copyRightYear: ''
        }
    }

    componentDidMount() {
        var current_year = new Date().getFullYear();
        this.setState({
            copyRightYear: current_year
        })
    }

    render() {
        return (
            <>
                <section id="legal">
                    <div className="container">
                        <p>
                            © {this.state.copyRightYear} <a href="https://www.s2pservices.co.uk/" target='__blank'>S2P SERVICES LIMITED</a> | All Right Reserved
                        </p>
                    </div>
                </section>
            </>
        );
    }
}

export default Legal;